<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">{{ isAT ? "Atividade" : "Tarefa" }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Horas"
              name="horas"
              type="number"
              required
              v-model="payload.horas"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <!-- <app-city-solution-combobox
              :municipioSolucao="edit ? payload : municipioSolucao"
              v-if="!filter.municipioSolucao || edit"
              :loadfirst="true"
            ></app-city-solution-combobox> -->

            <v-text-field
              v-model="municipioSolucao.nome"
              :label="`${isAT ? 'Iniciativa' : isGov? 'Fases': 'Solução'}`"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row v-if="estado === 'MS'">
          <v-col>
            <v-text-field
              label="Data de Finalização"
              name="dataFinalizacaoString"
              v-mask="'##/##/####'"
              type="text"
              required
              v-model="payload.dataFinalizacaoString"
            ></v-text-field>
          </v-col>
        </v-row>

        <div
          v-for="evidencia in payload.municipioEvidencias"
          v-bind:key="evidencia.municipioEvidenciaId"
        >
          <v-row>
            <v-col class="separator-list">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Nome da Evidência"
                required
                v-model="evidencia.nome"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                label="Descrição da Evidência"
                required
                v-model="evidencia.descricao"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="separator-list">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col>
            <v-btn
              outlined
              :large="false"
              :color="color"
              class="ml-3"
              @click="addEvidencia"
            >
              <v-icon>{{ icon }}</v-icon
              ><span>Adicionar Evidência</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import AppCitySolutionCombobox from "@/modules/city/components/terms-reference/solutions/Combobox.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertTask",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { type: Object, required: false },
    municipioSolucaoP: { type: Object, required: false },
  },
  components: {
    AppCitySolutionCombobox,
  },
  computed: {
    ...mapGetters(["user", "isAT", "isGov"]),
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        horas: 0,
        municipioEvidencias: [],
      },
      municipioSolucao: {},
      dialog: false,
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    close() {
      if (this.edit !== true) {
        this.payload = {
          municipioId: this.$route.params.id,
          horas: 0,
          municipioEvidencias: [],
          municipioSolucao: this.municipioSolucao,
        };
        this.municipioSolucao.municipioSolucao =
          this.municipioSolucaoP.municipioSolucaoo;
      } else {
        this.payload = { ...this.object };
        this.municipioSolucao.municipioSolucao = this.object.municipioSolucao;
      }
      this.dialog = false;
    },
    onConfirm() {
      this.setLoading(true);
      if (!this.municipioSolucao.municipioSolucaoId) {
        this.$notification.error(
          `O preenchimento de uma ${
            this.isAT ? "iniciativa" : this.isGov? 'fase': 'solução'
          } é obrigatório.`
        );
      } else {
        const valores = {
          ...this.payload,
          municipioSolucaoId: this.municipioSolucao.municipioSolucaoId,
          municipioSolucao: null,
        };

        if (this.edit === true) {
          cityTaskAPI
            .update(valores)
            .then((resp) => {
              this.dialog = false;
              this.payload = { ...this.object };
              this.setLoading(false);
              this.$emit("onSaveTask");
            })
            .catch();
        } else {
          cityTaskAPI
            .create(valores)
            .then((resp) => {
              this.dialog = false;
              this.payload = {
                monitoramento: 1,
                municipioId: this.$route.params.id,
              };
              this.setLoading(false);
              this.$emit("onSaveTask");
            })
            .catch();
        }
      }
    },
    addEvidencia() {
      this.payload.municipioEvidencias =
        this.payload.municipioEvidencias == null
          ? []
          : this.payload.municipioEvidencias;
      this.payload.municipioEvidencias.push({
        nome: "",
        descricao: "",
        municipioId: this.$route.params.id,
      });

      this.$forceUpdate();
    },
  },
  mounted() {
    this.municipioSolucao = this.filter.municipioSolucao;
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.object && this.edit === true) {
          this.payload = { ...this.object };
          this.municipioSolucao = this.payload.municipioSolucao;
          this.loadfirst = true;
        }
      }
    },
    "filter.municipioSolucao"(newValue) {
      if (newValue) {
        this.municipioSolucao = newValue;
      }
    },

    object(newValue) {
      this.payload = newValue;
      this.municipioSolucao = this.payload.municipioSolucao;
    },
  },
};
</script>
